import eventManager from "../../store/sqftEventManager";
import config from "../../store/sqftConfig";
import workspace from "../workspace";
import store from "../../../../../../store";
import $ from "jquery";
import {iconPlusBlack, iconPlusBlue} from "../../../../assetsSQFT";
import {setSQFTMenuOpened} from "../../../../../../actions/sqftMenuFunctions";
import {updateSQFTCalculations} from "../../../../../../actions/sqftFunctions";
import {attachResource} from "./resourseCanas";
import {SIDEBAR_NAVIGATION_BUTTONS} from "../../../../constants";

const backsplashCanvas = function() {
  let self = this;
  this.backSplashFeature = {
    size: 0,
    name: ""
  };
  this.cursorImage = null;
  this.addedImages = null; //like in edges
  this.img = null;
  this.isWaitingToRestoreCursor = false;

  this.setBackSplashFeature = function (backSplashFeature) {
    this.backSplashFeature = backSplashFeature;
  };
  this.setHighlighting = function (disallowDemo) {
    eventManager.stealCursor(true); // remove all other cursors
    workspace.setAllowEdges(false); //  removing sizing lines
    workspace.setAllowBumpoutEdges(false); //  removing bumpout lines
    config.highlight.points = false;	// remove radiuses
    config.highlight.lines = true;  // enable lines highlighting

    if (!disallowDemo) {
      config.highlight.demoShow = true;
    }
    setTimeout(function () {
      config.highlight.demoShow = false;
    }, 1000);
  };

  this.setCursorImage = function () {
    let bounds = 18,
      imgWidth = bounds,
      imgHeight = bounds;

    let domImg = document.createElement('img');
    domImg.crossOrigin = "Anonymous";

    let $img = $(domImg);
    $img.css({
      position: 'absolute',
      width: '1px',
      height: '1px'
    });

    $img.attr({
      'data-id': self.backSplashFeature.size,
      'data-name': self.backSplashFeature.name,
    });

    function imgOnLoad() {
      var bounds = 18;
      let ratio;
      if(imgWidth > imgHeight) {
        ratio = imgHeight / imgWidth;
        imgWidth = bounds;
        imgHeight = bounds * ratio;
      } else {
        ratio = imgWidth / imgHeight;
        imgHeight = bounds;
        imgWidth = bounds * ratio;
      }
      eventManager.setCursor('edge-select', self, true);
      self.cursorImage = { image: domImg, width: imgWidth, height: imgHeight };
      self.registerEvents(); // only after image is load!
    }
    $img.on('load', imgOnLoad);
    $img.appendTo($('body'));

    if (self.backSplashFeature.size === "wall") {
      config.highlight.type = 'wall';
      $img.attr('src', iconPlusBlack);
    } else {
      config.highlight.type = 'backsplash';
      $img.attr('src', iconPlusBlue);
    }

    this.img = $img;
    config.highlight.id = self.backSplashFeature.size;
  };

  this.registerEvents = () => {
    eventManager.setCursor('radius-select', self, true);
    eventManager.addEvent(
      eventManager.events.RENDER,
      this.renderCursor,
      this,
      eventManager.priorities.OVERALL
    );
    eventManager.addEvent(
      eventManager.events.MOUSE_UP,
      this.onMouseUp,
      this,
      eventManager.priorities.OVERALL
    );
  };
  this.deregisterEvents = () => {
    eventManager.resetCursor(this);
    eventManager.removeEvent(this);
    config.highlight.lines = false;
    //todo sqft-react
    //elements.navbacksplash.removeClass('steps-scope-config-button-selected');
  }
  this.destroy = function(protect, revertBackAfterMouseUp) {
    if (revertBackAfterMouseUp) {
      eventManager.removeEvent(self, eventManager.events.RENDER); //remove render only, but wait for mouse up to set cursor again
      this.isWaitingToRestoreCursor = true;
    } else {
      this.deregisterEvents();
      //$('img[data-id="' + this.img.data('id') +'"]').remove();
      //this.addedImages = this.addedImages.filter(image => image.dataset.id === this.img.data('id'));
    }
  };
  this.onMouseUp = function(mousePos) {
    void mousePos;
    let hoverShape = workspace.getHoverShape();
    if (hoverShape && hoverShape.getHoverSegment) {
      const reduxState = store.getState();
      const activeButton = reduxState.sqftMenuState.activeButton;
      if (activeButton !== SIDEBAR_NAVIGATION_BUTTONS.backsplash) {
        return
      }

      const segCorner = hoverShape.getHoverSegmentOutlineCorner();
      const seg = hoverShape.getHoverSegment();
      if (seg || segCorner) {
        let resourceType = (self.backSplashFeature.size === "wall") ? "wall" : "backsplash";

        //remove incompatible resources
        if (seg && seg.isWithMitered()) {
          seg.deleteMitered();
        } else if (seg && (seg.isWithWaterfallToolEdge() || seg.isWithPeninsulaUnderwrapEdge())) {
          seg.deleteAttachedItem();
        }

        //add new resource
        attachResource(seg, segCorner, resourceType, null, null, this.backSplashFeature.name, this.backSplashFeature.size);

        // let attachedTo = workspace.getImagesAttachedTo(seg);
        // if (attachedTo) {
        //   workspace.removeShape(attachedTo);
        // }
        //
        //
        // let historyCallBack;
        //
        // //add image to line or cornerLine
        // if (seg) {
        //   historyCallBack = seg.addBacksplashToLine.bind(self, this.backSplashFeature.name, type, self.cursorImage.image.dataset.id);
        // } else if (segCorner) {
        //   historyCallBack = segCorner.addBacksplashToCornerLine.bind(self, this.backSplashFeature.name, type, self.cursorImage.image.dataset.id);
        // }
        //
        // workspace.addImage(
        //   self.cursorImage.image,
        //   self.cursorImage.width /  scale,
        //   self.cursorImage.height / scale,
        //   seg || segCorner,
        //   hoverShape,
        //   type,
        //   historyCallBack
        // );
        //
        // historyCallBack();
        // config.highlight.lines = true;
      } else {
        store.dispatch(setSQFTMenuOpened('backsplash'));
        // 	deregisterEvents();
        // 	elements.designDefault.click();
      }

      const updateCalculations = reduxState.sqftState.updateCalculations;
      store.dispatch(updateSQFTCalculations(updateCalculations + 1));
    }
    this.checkForRestoreCursor();
  };
  this.checkForRestoreCursor = function() {
    if (self.isWaitingToRestoreCursor) {
      self.isWaitingToRestoreCursor = false;
      eventManager.removeEvent(self, eventManager.events.MOUSE_UP); //remove mouse up, it will be added in setCursorImage
      self.setHighlighting(true);
      self.setCursorImage();
    }
  };
  this.renderCursor = function(ctx) {
    // if((this.backsplashSize > 0) && ($(window).width() > 768)) {
    //   var mPos = eventManager.LastKnownMousePos;
    //   if(mPos) {
    //     ctx.save();
    //     ctx.font = "18px Arial";
    //     ctx.fillStyle = "#000000";
    //     ctx.fillText(this.backsplashSize + "\" Backsplash", mPos.x + (12 * config.scale), mPos.y + 9);
    //     ctx.restore();
    //   }
    // }
    if(self.cursorImage.image && ($(window).width() > 768)) {
      var mPos = eventManager.LastKnownMousePos;
      if(mPos) {
        ctx.drawImage(self.cursorImage.image, mPos.x + 10, mPos.y + 10, self.cursorImage.width, self.cursorImage.height);
      }
    }
  };
};

export default new backsplashCanvas();
